/* eslint-disable id-length */
import React, { Component } from 'react';

import language from '../../../../../assets/languages/language';
import { canvasjsConfig } from '../../../../../common/constant';
import { showFailure } from '../../../../../common/toast';
import LoaderWrapper from '../../../LoaderWrapper';
import { fetchCBTOverallUserGraph } from '../../../services';
import {
  eightyPercentLine,
  getTokenData,
  referenceLine,
  twentyPercentLine,
} from '../graphConstants';
import OverallGraph from './OverallGraph';

export default class OverallCanvasGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPointsOverAllGraph: [],
      isLoading: true,
    };
  }
  componentDidMount() {
    const tokenData = getTokenData();
    this.setState(tokenData);
    const { id = 0, testId = 0, totalQuestions, timer = 0, isNegative } = this.props.params;
    const data = {
      ...tokenData,
      mock_id: parseInt(id, 10),
      test_id: parseInt(testId, 10),
      totalQuestion: parseInt(totalQuestions, 10),
      timer: parseInt(timer, 10),
      isNegative,
    };
    this.getGraphoverAllGraphData(data);
  }

  getGraphoverAllGraphData = data => {
    fetchCBTOverallUserGraph(data).then(async res => {
      if (res.graphData) {
        const { totalQuestions } = this.props.params;
        const { averageScore = 0 } = res.graphData;
        this.setState({
          totalQuestions,
          average: averageScore,
        });
        this.setState({ isLoading: false });
        this.formatoverAllGraphData(res);
      } else showFailure(res.message);
    });
  };

  //format data as requirement for overall graph
  formatoverAllGraphData = res => {
    const { graphData } = res;

    this.setState({
      dataOfCurrentUser: graphData
        ? graphData.dataOfCurrentUser.score
        : this.state.dataOfCurrentUser,
      dataOfEightyPercentileUser: graphData
        ? graphData.dataOfEightyPercentileUser.score
        : this.state.dataOfEightyPercentileUser,
      dataOfTwentyPercentileUser: graphData
        ? graphData.dataOfTwentyPercentileUser.score
        : this.state.dataOfTwentyPercentileUser,
    });
    const { totalMarks } = this.props.params;

    //User score line
    const UserScoreOverAllGraph = {
      showInLegend: false,
      name: `${language.LC().GRAPHSCORE}`,

      type: 'line',
      color: '#1f8ceb',
      markerType: 'none',
      dataPoints: [],
      overlayBars: true,
    };
    //User score box

    const scorePercentage =
      graphData.dataOfCurrentUser.score == null
        ? 0
        : Math.ceil((graphData.dataOfCurrentUser.score / totalMarks) * 100);

    const UserScoreBoxOverAllGraph2 = {
      type: 'rangeColumn',

      color: 'hsl(200deg 67% 88%)',
      dataPoints: [],
    };

    UserScoreBoxOverAllGraph2.dataPoints.push({
      x: 1.39,

      y: [scorePercentage - 5, scorePercentage + 5],
    });

    const dataOfCurrentUserLineStart = {
      x: -0.2,

      y: scorePercentage,
    };
    const dataOfCurrentUserLineMid = {
      x: 2.8,

      y: scorePercentage,
    };
    const dataOfCurrentUserLineEnd = {
      x: 2.8,
      y: null,
    };

    UserScoreOverAllGraph.dataPoints.push(
      dataOfCurrentUserLineStart,
      dataOfCurrentUserLineMid,
      dataOfCurrentUserLineEnd,
    );

    const dataOfTwentyPercentileUserlineStart = {
      x: -3,

      y:
        graphData.dataOfTwentyPercentileUser.score == null
          ? 0
          : Math.ceil((graphData.dataOfTwentyPercentileUser.score / totalMarks) * 100),
    };
    const dataOfTwentyPercentileUserlineMid = {
      x: 7,

      y:
        graphData.dataOfTwentyPercentileUser.score == null
          ? 0
          : Math.ceil((graphData.dataOfTwentyPercentileUser.score / totalMarks) * 100),
    };
    const dataOfTwentyPercentileUserlineEnd = {
      x: 7,
      y: null,
    };
    const twentyPercentLineObj = { ...twentyPercentLine, dataPoints: [] };

    twentyPercentLineObj.dataPoints.push(
      dataOfTwentyPercentileUserlineStart,
      dataOfTwentyPercentileUserlineMid,
      dataOfTwentyPercentileUserlineEnd,
    );
    const dataOfEightyPercentileUserLineStart = {
      x: -3,

      y:
        graphData.dataOfEightyPercentileUser.score == null
          ? 0
          : Math.ceil((graphData.dataOfEightyPercentileUser.score / totalMarks) * 100),
    };
    const dataOfEightyPercentileUserLineMid = {
      x: 7,

      y:
        graphData.dataOfEightyPercentileUser.score == null
          ? 0
          : Math.ceil((graphData.dataOfEightyPercentileUser.score / totalMarks) * 100),
    };

    const dataOfEightyPercentileUserLineEnd = {
      x: 7,
      y: null,
    };
    const eightyPercentLineObj = { ...eightyPercentLine, dataPoints: [] };
    eightyPercentLineObj.dataPoints.push(
      dataOfEightyPercentileUserLineStart,
      dataOfEightyPercentileUserLineMid,
      dataOfEightyPercentileUserLineEnd,
    );
    const overAllGraphData = [];
    overAllGraphData.push(
      UserScoreBoxOverAllGraph2,
      twentyPercentLineObj,
      eightyPercentLineObj,
      UserScoreOverAllGraph,
      referenceLine,
    );

    this.setState({ dataPointsOverAllGraph: overAllGraphData }, () => {
      this.showGraphOverAll(); //Show overall graph
    });
  };

  //Show overall graph
  showGraphOverAll = () => {
    const { dataPointsOverAllGraph } = this.state;

    const chart = new window.CanvasJS.Chart('chartContainerOverAllGraph', {
      animationEnabled: true,
      axisY: canvasjsConfig.axisY,
      axisX: canvasjsConfig.axisX,

      toolTip: canvasjsConfig.toolTip,
      dataPointWidth: 90,
      dataPointMaxWidth: 80,
      dataPointMinWidth: 80,
      legend: { fontSize: 18 },
      data: dataPointsOverAllGraph,
      interactivityEnabled: false,
    });
    chart.render();
  };

  render() {
    const {
      average,
      dataOfCurrentUser,
      dataOfEightyPercentileUser,
      dataOfTwentyPercentileUser,
      isLoading,
    } = this.state;
    const { totalMarks = 1 } = this.props.params;

    return (
      <LoaderWrapper isLoading={isLoading}>
        <OverallGraph
          average={average}
          totalMarks={totalMarks}
          dataOfCurrentUser={dataOfCurrentUser}
          dataOfTwentyPercentileUser={dataOfTwentyPercentileUser}
          dataOfEightyPercentileUser={dataOfEightyPercentileUser}
        />
      </LoaderWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/ResultGraph/OverallGraph/index.jsx